<template>
  <RevDrawer :name :title>
    <template #body>
      <div class="mb-32">
        <RevIllustration
          alt=""
          class="w-full"
          :height="137"
          src="/img/reassurance/satisfaction-modal.svg"
          :width="327"
        />
      </div>
      <SatisfactionModalContent :cooling-off-days />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import SatisfactionModalContent from '../SatisfactionModalContent/SatisfactionModalContent.vue'

import translations from './SatisfactionModal.translations'

const i18n = useI18n()
const { features } = useMarketplace()
const { coolingOffDays } = features

defineProps<{
  name: string
}>()

const title = computed(() => {
  return i18n(translations.title, {
    days: coolingOffDays,
  })
})
</script>
